import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import AddressList from './components/AddressList';
import CategoryNav from './components/CategoryNav';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '草榴回家的路',
        url: 'https://caoliuhome.com/',
        description: '草榴回家的路官方导航站，提供草榴社区最新可用地址、访问教程与常见问题解答',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@type': 'WebSite',
        name: '草榴回家的路',
        url: 'https://caoliuhome.com/',
        description: '草榴回家的路是众多用户寻找草榴社区最新可用地址的核心指引',
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'WebPage',
        name: '草榴回家的路——官方导航与最新地址入口',
        description: '草榴回家的路是众多用户寻找草榴社区最新可用地址的核心指引。整合导航资源、备用域名入口、访问教程及常见问题解答。',
        url: 'https://caoliuhome.com/',
        isPartOf: {
          '@type': 'WebSite',
          name: '草榴回家的路',
        },
        primaryImageOfPage: {
          '@type': 'ImageObject',
          url: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20geometric%20background%20with%20soft%20golden%20and%20cream%20gradients&width=1800&height=900&seq=hero-bg-2026&orientation=landscape',
        },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '如何找到草榴社区最新可用地址？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过将本导航站加入浏览器书签来随时获取最新地址。我们会在地址更新后第一时间在本站发布公告。',
            },
          },
          {
            '@type': 'Question',
            name: '为什么有些地址无法访问？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '地址无法访问通常有DNS解析问题、网络运营商限制或服务器维护等原因，可以尝试清除DNS缓存或切换网络环境。',
            },
          },
          {
            '@type': 'Question',
            name: '推荐使用什么浏览器访问草榴社区？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '推荐使用Chrome、Firefox或Edge等主流浏览器的最新版本，这些浏览器对网页标准支持最为完善。',
            },
          },
          {
            '@type': 'Question',
            name: '手机端如何访问草榴社区？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '手机端访问与桌面端一致，使用浏览器打开本导航站提供的地址即可。社区网站已针对移动端做了响应式适配。',
            },
          },
          {
            '@type': 'Question',
            name: '地址失效了怎么办？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '首先确认是否为网络问题，可以尝试刷新页面、清除浏览器缓存、切换网络等操作。然后检查本导航站是否已发布最新地址公告。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <AddressList />
          <CategoryNav />
          <ArticleList />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}